import SvgOptions from "../../../Components/Svg/SvgOptions";
import SurveryDetails from "./SurveyDetails/SurveyDetails";
import SurveryList from "./SurveyList";

const SurveyNavOptions = [
	{
		element: SurveryDetails,
		path: ":id",
		access: { user: true, admin: true, super: true },
		Protected: false,
		default: true,
		icon: SvgOptions.Dashboard,
	},
];
const defaultRoute = {
	element: SurveryList,
	path: "*",
	access: { user: true, admin: true, super: true },
	Protected: false,
	default: true,
	icon: SvgOptions.Dashboard,
};
export { defaultRoute };
export default SurveyNavOptions;
